<div class="container-sm">
  <div class="flex">
    <img id="profile-img" src="assets/logo-blue.svg">
    <h1>World Data pro</h1>
  </div>
  <p class="label">by <b>WORLD DATA LAB</b></p>
  <hr class="divid" />
  <h2>{{title}}</h2>
</div>
